/**
     * @desc 1根据ID查询盲盒信息NoAuth
用于：盲盒详情页
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/getBoxById', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/getBoxById', params);
}
